export default () => {
  const header   = document.querySelector('header.page-header[data-page-header]');
  const skeleton = document.createElement('div');
  const closeSVGheader  = document.querySelector('.close-svg-header');
  const searchSVGHeader = document.querySelector('.search-mobile-icon .search-svg-header');

  skeleton.id    = 'bc-search-skeleton';
  skeleton.className = 'search-skeleton';
  skeleton.style.display = 'none';
  skeleton.innerHTML = `
      <div class="skeleton-icon"><svg class="search-svg-header" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.3749 15.2335C13.5874 15.2335 16.1917 12.6292 16.1917 9.41674C16.1917 6.20423 13.5874 3.59998 10.3749 3.59998C7.16236 3.59998 4.55811 6.20423 4.55811 9.41674C4.55811 12.6292 7.16236 15.2335 10.3749 15.2335Z" stroke="currentColor" stroke-miterlimit="10"/>
        <path d="M14.1746 13.8161L20.1978 19.2001" stroke="currentColor" stroke-miterlimit="10"/>
        </svg>
      </div>
      <div class="skeleton-input"><input id="skeleton-search-input" placeholder="Search" /></div>
  `;
  
  header.parentNode.insertBefore(skeleton, header.nextSibling);

  let hasBoostRendered = false;
  let skeletonInputValue = '';

  const updateElementHeroState = (element, iconSelector = '.search-svg-header') => {
    if (!element) return;
    
    const isHero = header.classList.contains('page-header--hero');
    const color = isHero ? '#fff' : '#000';
    
    if (isHero) {
      element.classList.add('page-header--hero');
    } else {
      element.classList.remove('page-header--hero');
    }
    
    const svg = element.querySelector(iconSelector);
    if (svg) {
      svg.querySelectorAll('path').forEach(p => p.setAttribute('stroke', color));
    }
  };

  const skeletonInput = skeleton.querySelector('#skeleton-search-input');

  const showSkeleton = () => {
    if (!hasBoostRendered) {
      skeleton.style.display = 'flex';

      if (skeletonInput) {
        setTimeout(() => skeletonInput.focus(), 100);
      }
    }
  };

  const hideSkeleton = () => {
    skeleton.style.display = 'none';
  };

  skeletonInput.addEventListener('input', (e) => {
    skeletonInputValue = e.target.value;
  });

  skeletonInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      const checkRealInput = setInterval(() => {
        const realInput = document.getElementById('bc-sf-search-box-mobile');

        if (realInput) {
          clearInterval(checkRealInput);
          realInput.placeholder = "Search";
          
          if (skeletonInputValue) {
            realInput.value = skeletonInputValue;
            realInput.focus();
            realInput.dispatchEvent(new Event('input', { bubbles: true }));
          } else {
            realInput.focus();
          }
        }
      }, 50);
    }
  });

  const watchBoostPanel = () => {
    const observer = new MutationObserver(() => {
      const panel = document.querySelector('.bc-sf-search-suggestion-mobile-top-panel');

      if (panel) {
        hasBoostRendered = true;

        document.getElementById('bc-sf-search-box-mobile').placeholder = "Search";

        hideSkeleton();
    
        panel.classList.add('open');
        closeSVGheader.style.display = '';
        searchSVGHeader.style.display = 'none';

        const realInput = document.getElementById('bc-sf-search-box-mobile');

        if (realInput && skeletonInputValue) {
          realInput.value = skeletonInputValue;
          realInput.focus();
          
          realInput.dispatchEvent(new Event('input', { bubbles: true }));
        } else if (realInput) {
          realInput.focus();
        }

        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };
  
  const watchDesktopInput = () => {
    const observer = new MutationObserver((_, obsrvr) => {
      const input = document.getElementById('bc-sf-search-box-0');
      if (input) {
        input.placeholder = 'Search';
        obsrvr.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  const earlyBtn = document.querySelector('.search-mobile-icon');

  watchDesktopInput();
  
  if (earlyBtn) {
    earlyBtn.addEventListener('click', e => {
      e.preventDefault();
      const panel = document.querySelector('.bc-sf-search-suggestion-mobile-top-panel');
      if (!panel) {
        showSkeleton();
        watchBoostPanel();
      } else {
        const mobileInput = document.getElementById('bc-sf-search-box-mobile');
        if (mobileInput) {
          mobileInput.placeholder = "Search";
        }
      }
    });
  }

  const attachToggle = () => {
    const btn = document.querySelector('.search-mobile-icon');
    const panel = document.querySelector('.bc-sf-search-suggestion-mobile-top-panel');
    const searchBtnHolder = document.querySelector('.bc-sf-search-btn-close-suggestion');
    const clearBtnHolder  = document.querySelector('.bc-sf-search-btn-clear-suggestion');
    const header = document.querySelector('header.page-header[data-page-header]');

    if (!btn || !panel) {
      setTimeout(attachToggle, 50);
      return;
    }

    // buttons inside .bc-sf-search-suggestion-mobile-top-panel
    const SEARCH_SVG = `
      <svg class="search-svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M10.3749 15.2335C13.5874 15.2335 16.1917 12.6293 16.1917 9.41676C16.1917 6.20425 13.5874 3.6 10.3749 3.6C7.16236 3.6 4.55811 6.20425 4.55811 9.41676C4.55811 12.6293 7.16236 15.2335 10.3749 15.2335Z" stroke="black" stroke-miterlimit="10"/>
        <path d="M14.1748 13.8161L20.1981 19.2001" stroke="black" stroke-miterlimit="10"/>
      </svg>`;
    const CLOSE_SVG = `
      <svg class="close-svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M18.75 5.25L5.25 18.75" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.75 18.75L5.25 5.25" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;

    searchBtnHolder.innerHTML = SEARCH_SVG;
    clearBtnHolder.innerHTML  = CLOSE_SVG;

    const searchSvg = searchBtnHolder.querySelector('svg');
    const closeSvg  = clearBtnHolder.querySelector('svg');
    closeSvg.style.display = 'none';
    const skeletonLoading = document.getElementById('bc-search-skeleton');

    const updateIconColor = () => {
      const isHero = panel.classList.contains('page-header--hero');
      const color  = isHero ? '#fff' : '#000';

      [searchSvg, closeSvg].forEach(svg =>
        svg.querySelectorAll('path').forEach(p => p.setAttribute('stroke', color))
      );

      const skeletonSvg = skeletonLoading.querySelector('.search-svg-header');

      if (skeletonSvg) {
        skeletonSvg.querySelectorAll('path').forEach(p => p.setAttribute('stroke', color));
      }
    };
    
    clearBtnHolder.addEventListener('click', e => {
      if (clearBtnHolder.style.display === 'none') {
        document.querySelector('.bc-sf-search-suggestion-wrapper.bc-sf-search-suggestion-mobile').style.display = 'none';
      }
    });


    btn.addEventListener('click', e => {
      e.preventDefault();

      if (document.querySelector('.bc-sf-search-suggestion-mobile-top-panel')) {
        panel.classList.toggle('open');

        if (panel.classList.contains('open')) {
          closeSvg.style.display = '';

          closeSVGheader.style.display = '';
          searchSVGHeader.style.display = 'none';

          skeletonInputValue = '';
          if (skeletonInput) skeletonInput.value = '';
          
          const realInput = document.getElementById('bc-sf-search-box-mobile');

          if (realInput) {
            setTimeout(() => realInput.focus(), 100);
          }
        } else {
          searchSvg.style.display = '';
          closeSvg.style.display = 'none';

          closeSVGheader.style.display = 'none';
          closeSVGheader.classList.add('hidden');
          searchSVGHeader.style.display = 'block';
        }

        setTimeout(manageHeaderBackground, 0);
      }
    });
  };

  attachToggle();

  const watchCloseSVGHeaderVisibility = () => {
    const target = document.querySelector('.close-svg-header');
    if (!target) return;
    const observer = new MutationObserver(() => {
      const isHidden = target.classList.contains('hidden') || target.style.display === 'none';
      if (isHidden) {
        document.body.classList.remove('bc-sf-search-suggestion-mobile-open');
      }
    });
    observer.observe(target, { attributes: true, attributeFilter: ['style', 'class'] });
  };
  watchCloseSVGHeaderVisibility();
  
  // click outside hide/close suggestino
  document.addEventListener('click', e => {
    const openPanel = document.querySelector('.bc-sf-search-suggestion-mobile-top-panel.open');
    const btn       = document.querySelector('.search-mobile-icon');
    if (!openPanel) return;

    if (
      !e.target.closest('.bc-sf-search-suggestion-mobile-top-panel') &&
      !e.target.closest('.search-mobile-icon') &&
      !e.target.closest('#bc-search-skeleton')
    ) {
      openPanel.classList.remove('open');

      document.querySelector('body').classList.remove('bc-sf-search-suggestion-mobile-open');
      document.querySelector('.close-svg-header').style.display = 'none';
      document.querySelector('.search-mobile-icon .search-svg-header').style.display = 'block';

      if (btn) {
        const [sv, cv] = btn.querySelectorAll('svg');
        sv.style.display = '';
        cv.style.display = 'none';
      }
    }
  });

  let wasHeroClass = false;
  let hasHeroNav = !!document.querySelector('[data-hero-nav-cover]');
    
  const shouldHaveHeroClass = () => {
    return hasHeroNav && window.scrollY <= 100;
  };

  const manageHeaderBackground = () => {
    const isSearchOpen = skeleton.style.display === 'flex' || 
      document.querySelector('.bc-sf-search-suggestion-mobile-top-panel.open') ||
      document.body.classList.contains('bc-sf-search-suggestion-mobile-open');
    
    if (isSearchOpen) {
      wasHeroClass = header.classList.contains('page-header--hero');
      header.classList.remove('page-header--hero');
    } else if (!isSearchOpen) {
      if (shouldHaveHeroClass()) {
        header.classList.add('page-header--hero');
      } else {
        header.classList.remove('page-header--hero');
      }
      wasHeroClass = false;
    }
  };  
  
  const originalShowSkeleton = showSkeleton;
  const originalHideSkeleton = hideSkeleton;
  
  window.showSkeleton = () => {
    originalShowSkeleton();
    manageHeaderBackground();
  };
  
  window.hideSkeleton = () => {
    originalHideSkeleton();
    manageHeaderBackground();
  };
  window.addEventListener('scroll', () => {
    const isSearchOpen = skeleton.style.display === 'flex' || 
      document.querySelector('.bc-sf-search-suggestion-mobile-top-panel.open') ||
      document.body.classList.contains('bc-sf-search-suggestion-mobile-open');
    
    if (isSearchOpen) {
      header.classList.remove('page-header--hero');
    }
  });
};
